import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';
import { Button } from '@lyse-as/formds-react';

import { colorNeutral } from 'src/styles/colors';
import { fontPrimary } from 'src/styles/fonts';
import { spacing2, spacing4 } from 'src/styles/spacing';

export const StyledButton = styled(Button)`
  display: flex;
  position: fixed;
  width: 100%;
  bottom: 0;
  height: 64px;
  z-index: 3;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${spacing2} 0 ${spacing4};
  border-radius: 0;
  border: 0;
  cursor: pointer;
`;

export const StyledText = styled(Typography)`
  color: ${colorNeutral};
  font-family: ${fontPrimary};
`;
